import { useEffect, useState } from 'react';
import { supabase } from '../supabase.js';
import { listCompanyReviews, ratingSummary } from './completion.js';

const day = (iso) => new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });

/** Public reviews for one supplier company. Renders nothing when there are no visible reviews. */
export function CompanyReviews({ organizationId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!supabase || !organizationId) return undefined;
    let active = true;
    listCompanyReviews(supabase, organizationId).then((value) => { if (active) setData(value); }).catch(() => undefined);
    return () => { active = false; };
  }, [organizationId]);
  const summary = ratingSummary(data);
  if (!data || !summary) return null;
  return <section className="account-content-panel">
    <h2>Reviews <small>· ★ {summary}</small></h2>
    <div className="coord-owned-list">{data.reviews.map((review) => <article key={review.id}>
      <p aria-label={`${review.rating} out of 5 stars`}><strong>{'★'.repeat(review.rating) + '☆'.repeat(5 - review.rating)}</strong> <small>{`${review.reviewer_label} · ${day(review.created_at)}${review.edited_at ? ' · edited' : ''}`}</small></p>
      <p style={{ whiteSpace: 'pre-wrap' }}>{review.body}</p>
      {review.response && <blockquote><strong>Response from the company</strong><p style={{ whiteSpace: 'pre-wrap' }}>{review.response.body}</p></blockquote>}
    </article>)}</div>
    <p><small>Respond to a review from the job it belongs to.</small></p>
  </section>;
}
